import axios from 'axios'
import { API_ENDPOINT } from '../../../config'
import store from '../../../redux/stores/store'

const getDefaultState = () => {
    return {
        loading: false,
        deletingId: null,
        hotels: [],
        filter: {
            column: "",
            value: ""
        },
        selectedIndex: -1,
        currentPage: 1,
        pageSize: 50,
        total: 0
    }
}

const loadHotels = instance => {
    instance.setState({ ...instance.state, loading: true })

    let criteria = {}
    if (instance.state.filter.column.length > 0 && instance.state.filter.value.length > 0) {
        criteria = {
            [instance.state.filter.column]: instance.state.filter.value
        }
    }

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/hotels",
        headers : {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            offset: (instance.state.currentPage - 1) * instance.state.pageSize,
            limit: instance.state.pageSize,
            criteria: criteria
        }
    }).then(response => handleLoadHotelsResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadHotelsResponse = (instance, response) => {
    if (response.data.status === 200) {
        instance.setState({
            ...instance.state,
            loading: false,
            hotels: response.data.data.hotels
        })
    }
    else if (response.data.status === 403) {
        instance.props.history.push('/auth/login')
    }
}

const HotelsWorker = instance => {
    const deleteHotel = id => {
        instance.setState({ ...instance.state, deletingId: id })
        axios({
            method: 'post',
            url: API_ENDPOINT + "/api/hotel/delete",
            headers : {
                "Authorization": store.getState().auth.authorization
            },
            data: {
                id: id
            }
        }).then(response => handleDeleteHotelResponse(instance, response, id))
        .catch(error => alert(error))
    }

    const handleDeleteHotelResponse = (instance, response, id) => {
        if (response.status === 200 && response.data.status === 200) {
            instance.setState({
                ...instance.state,
                deletingId: null,
                hotels: instance.state.hotels.filter((hotel) => hotel.id !== id)
            })
        }
        else if (response.data.status === 403) {
            instance.props.history.push('/auth/login')
        }
        else {
            instance.setState({
                ...instance.state,
                deletingId: null
            })
        }
    }

    return {
        loadHotels: () => loadHotels(instance),
        getDefaultState: () => getDefaultState(instance),
        deleteHotel: (id) => deleteHotel(id)
    }
}

export default HotelsWorker
